/**
 *  OCS Graphs 2.2.0
 *  This module initializes and creates the graphs (other than Meteogram, which is handled
 *    in Meteogram.js).
 *
 *	Requires Moolite 1.3
 *	Requires Highcharts
 *	Requires OCS Utilities 1.4.0
 *	Requires OCSAjaxManager 0.2.0
 *	Requires Jquery
 */


var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Chart = OCS.Chart || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.define_graph_class = function () {
    OCS.Classes.OCSGraph = new Class({
        Implements: [Options, Events, new Class(OCS.Interfaces.ExportGraph)],
        class_type: "graph",
        class_name: "OCSGraph",
        chart: null,
        data: {},
        debug: false,
        settings: null,
        ajax_manager: null,
        gNewDataFunctionRunning: false,
        refresh_process: null,
        loadinging_shown: false,
        options: {
            dynamic_tooltip: false,
            tooltip_shown: true,
            filename: 'chart',
            type: 'image/png',
            scale: 2,
            chart: {
                alignTicks: false,
                animation: false,
                marginLeft: 40,
                marginTop: 20,
                borderColor: '#4572A7',
                backgroundColor: '#FFFFFF',
                className: '',
                height: null,
                renderTo: 'graph',
                spacingBottom: 10,
                width: null,
                zoomType: 'x'
            },
            chart_credit: {text: 'www.mesonet.org', href: 'http://www.mesonet.org/'},
            chart_data: {},
            chart_exporting: {
                enabled: true
            },
            chart_loading: {
                hideDuration: 100,
                showDuration: 100,
                style: {
                    backgroundColor: 'gray',
                    opacity: 0.5
                },
                labelStyle: {
                    color: 'black'
                }
            },
            chart_navigation: {},
            chart_legend: {enabled: true},
            chart_plotOptions: {
                series: {
                    marker: {
                        enabled: false
                    }
                },
                area: {
                    shadow: false,
                    threshold: -900,
                    states: {
                        hover: {
                            enabled: false
                        }
                    },
                    events: {}
                },
                line: {
                    shadow: false,
                    states: {
                        hover: {
                            enabled: false
                        }
                    },
                    events: {}
                }
            },
            chart_subtitle: {},
            chart_title: {
                text: ""
            },
            chart_tooltip: {
                enabled: true,
                useHTML: true,
                shared: true,
                xDateFormat: '%m/%d/%Y - %l:%M %p',
                valueDecimals: 1,
                pointFormat: '<div class="meteogram_tooltip_line"><div class="meteogram_tooltip_label" style="color:{point.color}">{series.name}:</div> <div class="meteogram_tooltip_data">{point.y}</div><div class="clear"></div></div>',
                crosshairs: {
                    width: 1,
                    zIndex: 0
                },
                hideDelay: 0
            },
            auto_draw: true,
            global_store: true,
            site: "nrmn",
            dataset: "edu.ou.mesonet.standard",
            data_resolution: 300, // In seconds - 5 minutes
            date_start: null, // String date to start the timeseries for
            date_end: "latest", // String date to end the timeseries
            duration: "1d",
            duration_values: [],
            series: [],
            series_special_ops: [],
            series_xaxis: [],
            series_yaxis: [], //0 = left axis, 1 = right axis
            plot_lines: [],
            mesonet_url: 'http://www.mesonet.org/',
            mesonet_img_url: 'http://www.mesonet.org/images/global/mesonet_logo_small.png',
            data_url: '',
            refresh_rate: 60000,
            on_add_series: Function.convert(),
            on_click: Function.convert(),
            on_drilldown: Function.convert(),
            on_drillup: Function.convert(),
            on_drillupall: Function.convert(),
            on_load: Function.convert(),
            on_redraw: Function.convert(),
            on_refresh: Function.convert(),
            on_selection: Function.convert(),
            x_axis_ops: [],
            x_axis_defaults: {
                dateTimeLabelFormats: {
                    second: '%l:%M:%S %p',
                    minute: '%l:%M %p<br/>%m/%d/%Y',
                    hour: '%l:%M %p<br/>%m/%d/%Y',
                    day: '%l:%M %p<br/>%m/%d/%Y',
                    week: '%l:%M %p<br/>%m/%d/%Y',
                    month: '%l:%M %p<br/>%m/%d/%Y',
                    year: '%l:%M %p<br/>%m/%d/%Y'
                },
                tickLength: 4,
                tickWidth: 1,
                lineWidth: 1,
                type: 'datetime',
                showEmpty: true,
                labels: {
                    style:
                            {
                                color: '#343434',
                                fontSize: '9px'
                            }
                }
            },
            y_axis_ops: [],
            y_axis_titles: [], //index 0 = left yaxis title, index 1 = right yaxis title
            y_axis_minbuffer: 3,
            y_axis_defaults: {
                title: {
                    text: '',
                    style: {
                        background: '#ffffff'
                    }
                },
                opposite: false,
                lineWidth: 2,
                startOnTick: false,
                endOnTick: false,
                showEmpty: true,
                tickColor: '#C0D0E0',
                lineColor: '#C0D0E0',
                tickLength: 5,
                tickWidth: 1,
                tickPixelInterval: 36,
                showLastLabel: true,
                gridLineWidth: 0.5,
                offset: 0,
                labels: {
                    align: 'right',
                    y: 4,
                    x: -7,
                    style: {
                        color: '#000000',
                        fontSize: '9px'
                    }
                }
            },
            y_axis_right_defaults: {
                opposite: true,
                gridLineWidth: 0.0,
                labels: {
                    align: 'left',
                    x: 7
                }
            }
        },
        plot_lines_array: [],
        x_axis_array: [],
        y_axis_array: [],
        series_array: [],
        bound_methods: {},
        initialize: function (options) {
            this.debug_console("START INIT!");
            this.setOptions(options);
            var chart_obj = this;
            if (this.options.dynamic_tooltip) {
                this.options.chart_tooltip.formatter = function (tooltip) {
                    if (chart_obj.options.tooltip_shown) {
                        return chart_obj.chart.tooltip.defaultFormatter.call(this, tooltip);
                    } else {
                        return false;
                    }
                };
                this.options.chart_tooltip.positioner = function (labelWidth, y, point) {
                    var tooltipX, tooltipY;
                    if (point.plotX + labelWidth > this.chart.plotWidth) {
                        tooltipX = point.plotX + this.chart.plotLeft - labelWidth - 20;
                    } else {
                        tooltipX = point.plotX + this.chart.plotLeft + 20;
                    }
                    return {x: tooltipX, y: 10};
                };
            }

            this.initialize_events();
            this.debug_console(this.options);
            this.init_export_buttons();
            this.init_degree_sym();
            this.init_duration();

            if (this.options.global_store) {
                OCS.Chart[this.options.chart.renderTo] = this;
            }
        },
        initialize_events: function () {
            this.addEvent('start_data_refresh', this.on_start_refresh_process.bind(this));
            this.addEvent('stop_data_refresh', this.on_stop_refresh_process.bind(this));
            this.addEvent("pre_draw_graph", this.on_pre_draw_graph.bind(this));
            this.addEvent("post_draw_graph", this.on_post_draw_graph.bind(this));
            this.addEvent("new_data_processed", this.on_new_data_processed.bind(this));

        },
        /*
         * 
         * Actions
         * 
         */

        create_chart_ops: function () {
            return OCS.Utilities.combine_objects(this.options.chart, {events: {
                    addSeries: this.add_series_event.bind(this),
                    click: this.click_event.bind(this),
                    drilldown: this.drilldown_event.bind(this),
                    drillup: this.drillup_event.bind(this),
                    drillupall: this.drillupall_event.bind(this),
                    load: this.load_event.bind(this),
                    redraw: this.redraw_event.bind(this),
                    selection: this.selection_event.bind(this)
                }});
        },
        create_plot_ops: function () {
            var ops = OCS.Utilities.clone_object(this.options.chart_plotOptions);
            if (!ops.area.events.click) {
                ops.area.events.click = this.click_event.bind(this);
            }
            if (!ops.line.events.click) {
                ops.line.events.click = this.click_event.bind(this);
            }
            return ops;
        },
        create_plotlines_array: function () {
            var plot_lines_output = [];
            this.options.plot_lines.each(function (plot_line, i) { //loop through plot_lines array to create plotlines object
                //currently we only have a freezing line, but more plot_lines can be added.
                var new_plot_line = null;

                //plot freezing line
                if (plot_line.freezing) {
                    new_plot_line = {
                        value: 32,
                        width: 1,
                        color: 'blue',
                        dashStyle: 'dash',
                        zIndex: 4,
                        label: {
                            style: {
                                fontSize: '9px'
                            },
                            text: '32\xB0 F',
                            align: 'left',
                            y: -2,
                            x: 0
                        }
                    };
                }
                plot_lines_output.push(new_plot_line);
            }.bind(this));

            this.debug_console(plot_lines_output);
            this.plot_lines_array = plot_lines_output;
        },
        create_series_array: function () {
            var series_output = OCS.Utilities.clone_object(this.options.series);

            series_output.each(function (series) {
                if (series.data_var && series.data_units) {
                    var data_key = series.data_var + '|' + series.data_units;
                }
                var data = this.get_data_with_key({name: series.data_var, units: series.data_units});
                if (!this._is_all_null(data.data)) {
                    series.data = data.data;
                    series.data_var = data.key;
                    series.showInLegend = true;
                    series.trackByArea = true;
                    if (series.data.length > 1000) {
                        // This allows highcharts to display graphs larger than 1000 points.
                        series.turboThreshold = series.data.length;
                    }
                } else {
                    series.showInLegend = false;
                }


            }, this);

            this.debug_console("series output");
            this.debug_console(series_output);
            this.series_array = series_output;
        },
        create_tooltip_ops: function () {
            return this.options.chart_tooltip;
        },
        create_x_axis_array: function () {
            var x_axis_ops = OCS.Utilities.clone_object(this.options.x_axis_defaults);
            if (this.options.x_axis_ops) {
                x_axis_ops = OCS.Utilities.combine_objects(x_axis_ops, this.options.x_axis_ops);
            }
            if (x_axis_ops.offset === undefined && this.chart_index !== undefined) {
                x_axis_ops.offset = this.y_axis_array[0].top;
            }
            this.x_axis_array.push(x_axis_ops);
        },
        create_y_axis_array: function () {
            this.y_axis_array = [];
            var new_y_axis = {};
            var in_data = this.data;
            var overall_min = 999999;

            var yaxis_min_values = this._get_overall_yaxis_min();
            var yaxis_max_values = this._get_overall_yaxis_max();

            this.y_axis_array.push(this.create_y_axis_ops(this.options.y_axis_ops[0], yaxis_min_values[0], yaxis_max_values[0]));

            if (this.options.y_axis_ops.length > 1) {
                this.y_axis_array.push(this.create_y_axis_ops(this.options.y_axis_ops[1], yaxis_min_values[1], yaxis_max_values[1]));
            }

            this.debug_console("y_axis output");
            this.debug_console(this.y_axis_array);
        },
        create_y_axis_ops: function (ops, yaxis_min_value, yaxis_max_value) {
            var y_axis_ops = OCS.Utilities.clone_object(this.options.y_axis_defaults);
            var i = 0;
            if (this.y_axis_array.length) {
                y_axis_ops = OCS.Utilities.combine_objects(y_axis_ops, this.options.y_axis_right_defaults);
                i = 1;
            }
            y_axis_ops = OCS.Utilities.combine_objects(y_axis_ops, ops);


            if (this.plot_lines_array[i] !== null && this.plot_lines_array[i] !== undefined && !y_axis_ops.plotLines) {
                y_axis_ops.plotLines = [this.plot_lines_array[i]];
            }

            if (y_axis_ops.min === undefined) {
                if (yaxis_min_value !== undefined) {
                    y_axis_ops.min = yaxis_min_value;
                }
            } else { // a min is set
                // check for value under min and allow a change in the yaxis min if under
                if (yaxis_min_value < y_axis_ops.min) {
                    y_axis_ops.min = yaxis_min_value;
                }
            }

            if (y_axis_ops.max === undefined) {
                if (yaxis_max_value !== undefined) {
                    y_axis_ops.max = yaxis_max_value;
                }
            } else { // a max is set
                // check for value over max and allow a change in the yaxis max if over
                if (yaxis_max_value > y_axis_ops.max) {
                    y_axis_ops.max = yaxis_max_value;
                }
            }

            var data_buffer = 0;
            if (y_axis_ops.data_buffer !== undefined) {
                data_buffer = y_axis_ops.data_buffer;
            } else {
                data_buffer = this.options.y_axis_minbuffer;
            }

            if (data_buffer && y_axis_ops.min) {
                y_axis_ops.min -= data_buffer;
            }
            if (data_buffer && y_axis_ops.max) {
                y_axis_ops.max += data_buffer;
            }

            return y_axis_ops;

        },

        debug_console: function (msg) {
            if (this.debug) {
                if (OCS.Utilities.is_object(msg) || OCS.Utilities.is_array(msg)) {
                    console.log(this.class_name);
                    console.dir(msg);
                } else {
                    console.log(this.class_name + ": " + msg);
                }
            }
        },
        disable_chart_tooltip: function () {
            this.options.tooltip_shown = false;
//            this.options.chart_tooltip.enabled = false;
//            if (this.chart) {
//                this.chart.update({tooltip: {enabled: false}});
//            }
        },
        draw_graph: function () {
            this.fireEvent('pre_draw_graph', this);

            Highcharts.setOptions({
                global: {
                    useUTC: false
                }
            });
            // create the chart

            var chart_ops = {
                chart: this.create_chart_ops(),
                credits: this.options.chart_credit,
                exporting: this.options.chart_exporting,
                legend: this.options.chart_legend,
                loading: this.options.chart_loading,
                plotOptions: this.create_plot_ops(),
                series: this.series_array,
                title: this.options.chart_title,
                tooltip: this.create_tooltip_ops(),
                xAxis: this.x_axis_array,
                yAxis: this.y_axis_array
            };
            /* istanbul ignore if */
            if (this.options.chart_data && Object.keys(this.options.chart_data).length) {
                chart_ops.data = this.options.chart_data;
            }
            /* istanbul ignore if */
            if (this.options.chart_navigation && Object.keys(this.options.chart_navigation).length) {
                chart_ops.navigation = this.options.chart_navigation;
            }
            /* istanbul ignore if */
            if (this.options.chart_subtitle && Object.keys(this.options.chart_subtitle).length) {
                chart_ops.subtitle = this.options.chart_subtitle;
            }
            if (this.chart) {
                this.chart.showLoading();
                this.chart.destroy();
                this.loadinging_shown = true;
            }
            this.showSpinner();
            this.chart = new Highcharts.Chart(chart_ops);

            this.fireEvent('post_draw_graph', this, 1);
            this.fireEvent("graph_drawn", this, 1);
            //this.chart.renderer.image(this.options.mesonet_img_url, 650, 340, 81, 20).add().attr({zIndex: 18});        
        },

        enable_chart_tooltip: function () {
            this.options.tooltip_shown = true;
            //this.options.chart_tooltip.enabled = true;
//            if (this.chart) {
//                this.chart.update({tooltip: {enabled: true}});
//            }
        },

        init_degree_sym: function () {
            Array(this.options.y_axis_ops).each(function (y_axis_title, i) { //loop through data_names array to create series object
                if (y_axis_title.title && y_axis_title.title.text) {
                    this.options.y_axis_ops[i].title.text = y_axis_title.title.text.replace("&deg;", "\xB0");
                }
            }.bind(this));

            this.options.chart_title.text = this.options.chart_title.text.replace("&deg;", "\xB0");
        },
        init_duration: function () {
            var duration_html = "";
            this.options.duration_values.each(function (duration_value, i) { //loop through data_names array to create series object
                var unit = duration_value.slice(-1);
                var duration_string = duration_value.slice(0, -1);
                var unit_string = "";

                switch (unit) {
                    case 'm':
                        if (duration_string === "1") {
                            unit_string = " Minute";
                        } else {
                            unit_string = " Minutes";
                        }
                        break;
                    case 'h':
                        if (duration_string === "1") {
                            unit_string = " Hour";
                        } else {
                            unit_string = " Hours";
                        }
                        break;
                    case 'd':
                        if (duration_string === "1") {
                            unit_string = " Day";
                        } else {
                            unit_string = " Days";
                        }
                        break;
                    case 'w':
                        if (duration_string === "1") {
                            unit_string = " Week";
                        } else {
                            unit_string = " Weeks";
                        }
                        break;
                    default:
                        /* istanbul ignore if */
                        if (duration_string === "1") {
                            unit_string = " Day";
                        } else {
                            unit_string = " Days";
                        }
                        break;
                }

                duration_html += "<option value='" + duration_value + "' ";

                if (this.get_duration() === duration_value) {
                    duration_html += 'selected="selected"';
                }

                duration_html += ">" + duration_string + unit_string + "</option>";
            }.bind(this));
            var dur_el = jQuery("#duration");
            dur_el.html(duration_html);
            dur_el.change(function () {
                this.showSpinner();
                this.set_duration(jQuery('#duration').val());
            }.bind(this));

        },

        /*
         * hideSpinner
         * 
         * Removes a div containing a loading spinner in div class 'graph'
         */
        hideSpinner: function () {
            jQuery(".spinner").remove();
        },

        init_refreshing_graph: function () {
            this.fireEvent('start_data_refresh', this, 1);
            this.request_data();
        },
        init_export_buttons: function () {

        },

        refresh_data: function () {
            this.request_data();
            if (this.options.on_refresh) {
                this.options.on_refresh();
            }
            this.bound_methods.on_refreshed_data = this.on_refreshed_data.bind(this);
            this.addEvent('new_data_processed', this.bound_methods.on_refreshed_data);
        },
        request_data: function () {
            var url = this.get_request_url();
            var am = this.get_ajax_manager();
            var req = am.request(url, {url: url, type: "Post", dataType: 'json', noCache: true});
            req.addEvent('success', this.on_request_success.bind(this));
            req.send();
        },

        /*
         * showSpinner
         * 
         * Shows a div containing a loading spinner in div class 'graph'
         */
        showSpinner: function () {
            jQuery('<div class="spinner"><img src="/images/ajax-loader.gif" style="vertical-align:-25%"> Loading...</div>').css({
                position: 'absolute',
                display: 'none',
                top: 15,
                left: 65,
                border: '1px solid #fdd',
                padding: '2px',
                'background-color': '#fee',
                opacity: 0.80
            }).appendTo(".graph").fadeIn(200);
        },

        /*
         * 
         * Event Fires
         * 
         */
        add_series_event: function (e) {
            this.fireEvent('add_series', [this, e], 1);
        },
        click_event: function (e) {
            this.fireEvent('click', [this, e], 1);
        },
        drilldown_event: function (e) {
            this.fireEvent('drilldown', [this, e], 1);
        },
        drillup_event: function (e) {
            this.fireEvent('drillup', [this, e], 1);
        },
        drillupall_event: function (e) {
            this.fireEvent('drillupall', [this, e], 1);
        },
        redraw_event: function (e) {
            this.fireEvent('graph_redrawn', [this, e], 1);
        },
        load_event: function (e) {
            this.fireEvent('load', [this, e], 1);
        },
        selection_event: function (e) {
            this.fireEvent('selection', [this, e], 1);
            //this.series[9].options.marker.enabled = true;
        },

        /*
         * 
         * Event Listeners
         * 
         */
        on_container_mouse_move_event: function (e) {
            if (this.chart) {

            }
        },
        on_document_mouse_move_event: function (e) {
            if (this.chart) {
                this.chart.pointer.onDocumentMouseMove(e);
            }
        },
        on_duration_change_data_refresh: function () {
            this.removeEvent('data_refreshed', this.bound_methods.on_duration_change_data_refresh);
            this.fireEvent('duration_changed', this);
        },
        on_new_data_processed: function () {
            if (this.options.auto_draw) {
                this.draw_graph();
            }
        },
        on_pre_draw_graph: function () {
            this.x_axis_array = [];
            this.y_axis_array = [];
            this.series_array = [];
            this.plot_lines_array = [];
            this.create_series_array();
            this.create_plotlines_array();
            this.create_y_axis_array();
            this.create_x_axis_array();
        },
        on_post_draw_graph: function () {
            if (this.loadinging_shown) {
                this.loadinging_shown = false;
                this.chart.hideLoading();
            }
            this.hideSpinner();
        },
        on_refreshed_data: function () {
            this.removeEvent('new_data_processed', this.bound_methods.on_refreshed_data);
            this.fireEvent('data_refreshed', this);
        },
        on_start_refresh_process: function () {
            if (!this.refresh_process && this.options.refresh_rate) {
                this.refresh_process = setInterval(this.refresh_data.bind(this), this.options.refresh_rate);
                this.fireEvent('refresh_process', [this, {'status': 'active'}]);
            }
        },
        on_stop_refresh_process: function () {
            if (this.refresh_process) {
                clearInterval(this.refresh_process);
                this.refresh_process = null;
                this.fireEvent('refresh_process', [this, {'status': 'inactive'}]);
            }
        },

        on_request_success: function (jsonData) {
            if (jsonData.error) {
                return false;
            }
            if (jsonData && jsonData.json && jsonData.json.data) {
                this.set_data(jsonData.json.data);
                this.fireEvent('new_data_processed', this, 1);
            }
        },

        /*
         * 
         * Boolean Methods
         * 
         */
        _is_all_null: function (data) {
            if (data && data[0]) {
                var i;
                if (data[0].x !== null && data[0].x !== undefined) {
                    for (i = 0; i < data.length; i++) {
                        if (data[i].y !== null && data[i].y !== undefined) {
                            return false;
                        }
                    }
                } else {
                    for (i = 0; i < data.length; i++) {
                        if (data[i][1] !== null) {
                            return false;
                        }
                    }
                }
            }
            return true;
        },
        is_chart_tooltip_enabled: function () {
            return this.options.chart_tooltip.enabled;
        },

        /*
         * 
         * Get / Set Methods
         * 
         */
        get_ajax_manager: function () {
            if (!this.ajax_manager) {
                this.ajax_manager = new OCS.Classes.AjaxManager();
            }
            return this.ajax_manager;
        },
        get_chart: function () {
            return this.chart;
        },
        get_chart_container: function () {
            if (this.chart) {
                return this.chart.container;
            }
        },
        get_chart_index: function () {
            return this.chart_index;
        },
        get_dataset: function () {
            return this.options.dataset;
        },
        get_dataset_obj: function () {
            var name = this.get_dataset();
            /* istanbul ignore else */
            if (OCS.Datasets[name]) {
                return OCS.Datasets[name];
            } else {
                return new OCS.Classes.Dataset();
            }
        },
        get_data_names: function () {
            var output = [];
            var variable;
            this.options.series.each(function (series) {
                if (series.data_var) {
                    if (output.contains(series.data_var) && series.data_units) {
                        variable = series.data_var + '|' + series.data_units;
                    } else {
                        variable = series.data_var;
                    }
                    output.append([variable]);
                }
            });

            return output;
        },
        get_date_url_settings: function () {
            var url_string = "";
            if (this.options.date_start !== null) {
                url_string += "sdate/" + this.options.date_start;
            } else {
                url_string += "timespan/" + this.get_duration();
            }
            if (this.options.date_end !== null) {
                url_string += "/edate/" + this.options.date_end;
            }
            if (this.options.data_resolution) {
                url_string += "/interval/" + this.options.data_resolution;
            }
            return url_string;
        },
        get_duration: function () {
            return this.options.duration;
        },
        get_chart_height: function () {
            var height = 0;
            if (this.chart) {
                height = this.chart.chartHeight;
            } else {
                height = this.options.chart.height;
            }
            return height;
        },
        get_chart_width: function () {
            var width = 0;
            if (this.chart) {
                width = this.chart.chartWidth;
            } else {
                width = this.options.chart.width;
            }
            return width;
        },
        get_data_with_key: function (data_key) {
            var data = [];
            var key;
            if (data_key.name && data_key.units) {
                key = data_key.name + '|' + data_key.units;
            } else {
                key = data_key.name;
            }

            if (this.data[key]) {
                data = this.data[key];
            } else {
                key = data_key.name;
                if (this.data[key]) {
                    data = this.data[key];
                }
            }
            return {data: data, key: key};
        },
        get_reference_point: function (e) {
            if (this.chart) {
                return this.chart.series[0].searchPoint(this.chart.pointer.normalize(e.originalEvent), true);
            }
        },
        get_request_url: function () {
            if (this.options.data_url) {
                return this.options.data_url;
            }

            var url_settings = {stid: this.options.site, other: "timestamps/1/date_keyed/0"};
            url_settings.date_settings = this.get_date_url_settings();
            url_settings.var_settings = this.get_var_settings();

            var dataset_obj = this.get_dataset_obj();
            return dataset_obj.get_url(url_settings, 'timeseries_netcdf');
        },
        get_var_settings: function () {
            var req_vars = [];
            var req_units = [];
            if (this.options.series.length) {
                if (this.options.series && this.options.series.length) {
                    this.options.series.each(function (series) {
                        if (series.data_var) {
                            req_vars.push(series.data_var);
                        }
                        if (series.data_units) {
                            req_units.push(series.data_units);
                        }
                    });
                }

                if (this.options.data_names && this.options.data_names.length) {
                    req_vars.combine(this.options.data_names);
                }
                if (this.options.data_units && this.options.data_units.length) {
                    req_units.combine(this.options.data_units);
                }
            }
            var var_settings;
            if (req_vars.length) {
                var_settings = 'var/' + req_vars.join();
                if (req_units.length) {
                    var_settings += '/units/' + req_units.join();
                }
            }
            return var_settings;
        },
        get_x_axis_array: function () {
            return this.x_axis_array;
        },
        get_y_axis_array: function () {
            return this.y_axis_array;
        },
        get_series_array: function () {
            return this.series_array;
        },
        set_data: function (data) {
            this.data = data[0];
        },
        set_debug: function (val) {
            this.debug = val;
        },
        set_duration: function (val) {
            this.options.duration = val;
            this.refresh_data();
            this.bound_methods.on_duration_change_data_refresh = this.on_duration_change_data_refresh.bind(this);
            this.addEvent('data_refreshed', this.bound_methods.on_duration_change_data_refresh);
        },
        set_x_axis_array: function (array) {
            this.x_axis_array = array;
        },
        set_y_axis_array: function (array) {
            this.y_axis_array = array;
        },
        set_chart_index: function (i) {
            this.chart_index = i;
        },
        set_extremes: function (e) {
            if (this.chart && this.chart.xAxis[0].setExtremes) {
                this.chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {trigger: 'syncExtremes'});
            }
        },
        _get_max_no_null: function (data) {
            if (data && !this._is_all_null(data)) {
                if (typeof data[0] !== 'undefined' && typeof data[0].y !== 'undefined') {
                    return this._get_max_no_null_obj(data);
                } else {
                    return this._get_max_no_null_array(data);
                }
            } else {
                return null;
            }
        },
        _get_max_no_null_obj: function (data) {
            if (data)
            {
                var max = data[0].y;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].y && data[i].y !== null) {
                        if(max === null) {
                            max = data[i].y;
                        }                          
                        max = (data[i].y > max) ? data[i].y : max;
                    }
                }
                return max;
            }
        },
        _get_max_no_null_array: function (data) {
            if (data)
            {
                var max = data[0][1];
                for (var i = 0; i < data.length; i++) {
                    var check = data[i][1] !== null;
                    if (data[i][1] && data[i][1] !== null) {
                        if(max === null) {
                            max = data[i][1];
                        }                         
                        max = (data[i][1] > max) ? data[i][1] : max;
                    }
                }
                return max;
            }
        },
        _get_overall_yaxis_max: function () {
            var in_data = this.data;
            var yaxis_maxs = [];
            yaxis_maxs[0] = undefined;
            yaxis_maxs[1] = undefined;

            this.series_array.each(function (series) {
                if (series.type === 'area' || series.type === 'line') {
                    if (yaxis_maxs[series.yAxis] === undefined) {
                        yaxis_maxs[series.yAxis] = -990;
                    }
                    var temp_max = this._get_max_no_null(in_data[series.data_var]);
                    if (temp_max !== null && temp_max > yaxis_maxs[series.yAxis]) {
                        yaxis_maxs[series.yAxis] = temp_max;
                    }
                }
            }, this);

            this.debug_console(yaxis_maxs);
            return yaxis_maxs;
        },
        _get_min_no_null: function (data) {
            if (data && !this._is_all_null(data)) {
                if (typeof data[0] !== 'undefined' && typeof data[0].y !== 'undefined') {
                    return this._get_min_no_null_obj(data);
                } else {
                    return this._get_min_no_null_array(data);
                }
            } else {
                return null;
            }
        },
        _get_min_no_null_obj: function (data) {
            if (data) {
                var min = data[0].y;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].y && data[i].y !== null) {
                        if(min === null) {
                            min = data[i].y;
                        }                        
                        min = (data[i].y < min) ? data[i].y : min;
                    }
                }
                return min;
            }
        },
        _get_min_no_null_array: function (data) {
            if (data) {
                var min = data[0][1];
                for (var i = 0; i < data.length; i++) {
                    var check = data[i][1] !== null;
                    if (data[i][1] && data[i][1] !== null) {
                        if(min === null) {
                            min = data[i][1];
                        }
                        min = (data[i][1] < min) ? data[i][1] : min;
                    }
                }
                return min;
            }
        },
        _get_overall_yaxis_min: function () {
            var in_data = this.data;
            var yaxis_mins = [];
            yaxis_mins[0] = undefined;
            yaxis_mins[1] = undefined;

            this.series_array.each(function (series) {
                if (series.type === 'area') {
                    if (yaxis_mins[series.yAxis] === undefined) {
                        yaxis_mins[series.yAxis] = 9999;
                    }
                    var temp = this._get_min_no_null(in_data[series.data_var]);
                    if (temp !== null && temp < yaxis_mins[series.yAxis]) {
                        yaxis_mins[series.yAxis] = temp;
                    }
                }
            }, this);

            this.debug_console(yaxis_mins);
            return yaxis_mins;
        },

        /*
         * 
         * Class destruction methods
         * 
         */
        destroy: function () {
            this.on_stop_refresh_process();
            this.removeEvents();
            this.chart = null;
            this.data = {};
        }

    });
};
OCS.Functions.define_graph_class();
